import moment from 'moment';
import {CourseMakeup} from '@/documentTypes/course-manager/Course.document';

/** Calendar marker of a make-up course ("Nachholtermin", Course.makeup) - pure, used by occurrenceModel */
export interface MakeupLessonInfo {
    /** "Ersatz für K1 (Mo 05.10.)" (all cancelled lessons) */
    text: string;
    /** Primary cancelled lesson (link "Ausgefallene Stunde anzeigen") */
    sourceCustomId: string;
    /** 'YYYY-MM-DD HH:mm' */
    sourceStart: string;
    sourceCount: number;
}

export function makeupInfoOf(makeup: CourseMakeup | null | undefined): MakeupLessonInfo | undefined {
    if (!makeup?.sourceCourseCustomId || !makeup.sourceDate) {
        return undefined;
    }
    const sources = makeup.sources?.length ? makeup.sources : [{courseCustomId: makeup.sourceCourseCustomId, date: makeup.sourceDate, durationMinutes: makeup.sourceDurationMinutes}];
    const parts = [...sources]
        .sort((a, b) => moment(a.date).valueOf() - moment(b.date).valueOf())
        .map((s) => `${s.courseCustomId} (${moment(s.date).format('dd DD.MM.')})`);
    return {
        text: `Ersatz für ${Array.from(new Set(parts)).join(', ')}`,
        sourceCustomId: makeup.sourceCourseCustomId,
        sourceStart: moment(makeup.sourceDate).format('YYYY-MM-DD HH:mm'),
        sourceCount: sources.length,
    };
}
